// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selectLabel[data-v-e3e6ec34]  .el-input__inner {\n  height: 28px !important;\n  line-height: 28px !important;\n  border: none;\n  font-weight: bold !important;\n  text-align: left;\n  padding-left: 0;\n}\n.selectLabel[data-v-e3e6ec34]  .el-input__icon {\n  line-height: 28px !important;\n}", ""]);
// Exports
module.exports = exports;
